/** TanStack Query key factory for learner curriculum enrollment reads. */
export const LEARNER_CURRICULUM_ROOT = 'learner-curriculum' as const;

export function learnerCurriculumQueryKey(opts: {
  membershipKey: string;
  /** Platform user id — isolates cache across learner login switches. */
  platformUserKey: string;
}) {
  return [LEARNER_CURRICULUM_ROOT, opts.membershipKey, opts.platformUserKey] as const;
}
